/*  ==========================================================================
    DYNFORMS CONFIG
    ========================================================================== */

// local imports
import * as dynFileLoader from './../../utilities/lib/dyn-file-loader';
import {globalDynForms, specificDynforms} from "./config";
import * as vars from '../../globals/variables';
import $ from "jquery";

const BN = window.BN = window.brandnamic = window.brandnamic || window.BN || {};

const initDynform = () => {
    let forms = $('.bn_dynForm');

    forms.each(function () {
        let form_container = $(this);

        if(!form_container.hasClass('bn-dynformInit') && form_container[0].id !== "") {

            let container_id = form_container[0].id,
                dynform_code = form_container.data('dynform_code'),
                dyform_options = form_container.data('dynform_options'),
                confirmPath = document.querySelector("meta[name='confirm-path']").getAttribute("content");

            // global config
            let dynFormConfig = $.extend(true, vars.dynformsGlobalConfig, {});

            // dynform_code specific
            if (globalDynForms[dynform_code]) {
                dynFormConfig = $.extend({}, dynFormConfig, globalDynForms[dynform_code]);
            }
            // container id specific
            if (specificDynforms[container_id]) {
                dynFormConfig = $.extend({}, dynFormConfig, specificDynforms[container_id]);
            }
            // data-options specific
            if(dyform_options !== '' && dyform_options !== undefined) {
                dynFormConfig = $.extend({}, dynFormConfig, dyform_options);
            }

            dynFormConfig = $.extend({}, dynFormConfig, {
                formContainerId: container_id,
                dynFormCode: dynform_code,
                doubleOptUrl: 'https://confirm.brandnamic.com/?lang=' + vars.lang + '&redirect=' + window.location.protocol + '//' + window.location.host + confirmPath
            });

            // data log (only if user is logged in typo3)
            if($('body').hasClass('be-user')) {
                console.log('----------------------------------------------------------------------------------------------------');
                console.log('DYNFORM(' + dynform_code + '): #' + container_id);
                console.log(dynFormConfig);
                console.log('----------------------------------------------------------------------------------------------------');
            }

            BN.DynFormsV2(dynFormConfig);
        }
    });
};

const dynFileConfig_dynForm = {
    dynForm: {
        src: 'https://admin.ehotelier.it/js/dynformsv2.js',
        onLoad: () => {
            // Save callback variable to the window variable, to initialize the dynform script also on async requests
            BN.DynFormsV2 = BnForms.DynFormsV2;
            initDynform();
        }
    }
};

// const dynFileConfig_referrer = {
//     referer: {
//         src: 'https://referrer.bnamic.com/referrer/referrer.js',
//         onLoad: () => {
//             dynFileLoader.load(dynFileConfig_dynForm, 'js');
//         },
//         onError: () => {
//         }
//     }
// };
dynFileLoader.load(dynFileConfig_dynForm, 'js');

export {initDynform};


// WEBPACK FOOTER //
// ./source/js/ehotelier/dynforms/init.js